<template>
  <div :class="['wrapper', classes]" refs="box-wrapper">
    <header class="main-header" ref='mainHeader'>

		<a href="/" class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini" style="text-align:center"><b>ICP</b> </span>
        <!-- logo for regular state and mobile devices -->
        <img class="img-responsive" style="width:85%; margin:0 auto; padding:2px 5px 5px 0" :src="logo">
      </a>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">

            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <!-- The user image in the navbar-->
                <img v-bind:src="user_current.avatar" class="user-image" alt="User Image">
                <!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="hidden-xs">{{ user_current.displayName }}</span>
              </a>

               <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                 <img v-bind:src="user_current.avatar" class="img-circle" alt="User Image">

                <p>
                 {{ user_current.displayName }}
                </p>
              </li>

              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <a href="#" class="btn btn-default btn-flat">Perfil</a>
                </div>
                <div class="pull-right">
                  <a href="javascript:void(0)" class="btn btn-default btn-flat" v-on:click="logout">Sair</a>
                </div>
              </li>
            </ul>

            </li>

          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <aside class="main-sidebar">

      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar">
        <!-- Sidebar Menu -->
        <sidebar-menu />
        <!-- /.sidebar-menu -->
      </section>
      <!-- /.sidebar -->
    </aside>


    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper" :style="{ 'min-height': fullHeight+'px' }">
      <!-- Content Header (Page header) -->


      <router-view></router-view> <!-- Componente chamado na rota é renderizado aqui dentro -->
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer" ref='mainFooter'>
      <strong>Copyright &copy; {{year}}
        <a href="javascript:;">Credipremium</a>.</strong> Todos os direitos reservados.
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import SidebarMenu from './SidebarMenu'
import 'hideseek'

export default {
  name: 'Dash',
  mounted () {
    this.fullHeight = window.innerHeight-this.$refs.mainFooter.clientHeight-this.$refs.mainHeader.clientHeight-2;
  },
  data: function () {
    return {
      section: 'Dash',
      logo: `${this.$store.state.serverURI}/images/logo-premium.png`,
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: '',
      fullHeight: '',
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    user_current () {
      return {
        displayName: this.$store.state.user.name,
        avatar: `${this.$store.state.serverURI}/images/default-avatar.png`,
        email: this.$store.state.user.email,
      }
    }
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    logout () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }

        this.$router.push('/login')
      },
  },
  components: {
    SidebarMenu
  },
}
</script>

<style lang="scss">
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  img {
    padding: .4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}
.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.skin-blue .main-header .navbar{
  background-color: #000;
}

.skin-blue .main-header .navbar:hover{
  background-color: #000;
}

.skin-blue .main-header .logo {
  background-color: #000;
}

.skin-blue .main-header li.user-header {
  background-color: #000;
}

.skin-blue .main-header .logo:hover {
    background-color: #111;
}

.skin-blue .main-header .navbar .sidebar-toggle:hover {
    background-color: #111;
}




</style>



// WEBPACK FOOTER //
// Dash.vue?eed1c5f2